import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import axios from "axios";
import _ from "lodash";
import App from "./components/App";

// import { initializeApp } from "firebase/app";
// import { getAnalytics, logEvent } from "firebase/analytics";
// import { getPerformance, trace } from "firebase/performance";

import { fetchBrand } from "./actions/appActions";
import { fetchUser } from "./actions/accountActions";

import * as serviceWorker from "./serviceWorker";
import store from "./store";
import {
  getSubdomain,
  getApiKeyFromSubdomain,
  getColorVar,
} from "./components/utils/Utils";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import { FALLBACK_LANGUAGE, COMPONENT_TYPE } from "./styles/utils/constants";

switch (process.env.REACT_APP_BUILD_MODE) {
  case "development":
    axios.defaults.baseURL = "https://dev-api.go-evio.com";
    break;
  case "qa":
    axios.defaults.baseURL = "https://pre-api.go-evio.com";
    break;
  case "production":
    axios.defaults.baseURL = "https://api.go-evio.com";
    break;
  case "pre-production":
    axios.defaults.baseURL = "https://pre-api.go-evio.com";
    break;
  default:
    axios.defaults.baseURL = "https://dev-api.go-evio.com";
}

// get subdomain
const subdomain = getSubdomain(window.location.hostname);
const apikey = getApiKeyFromSubdomain(subdomain);

// get store state
const state = store.getState();
// set default headers for axios requests
if (!!!axios.defaults.headers.common["language"]) {
  axios.defaults.headers.common["language"] =
    state.i18n.locale || FALLBACK_LANGUAGE;
}
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["component"] = COMPONENT_TYPE;
axios.defaults.headers.common["apikey"] = apikey;
axios.defaults.headers.common["token"] = state.account.token;
axios.defaults.headers.common["refreshtoken"] = state.account.token;

// load client brand details
store.dispatch(fetchBrand()).then((state) => {
  // load client brand theme colors
  if (state?.app?.brand?.colors) {
    const style = document.documentElement.style;
    const colors = state?.app?.brand?.colors;
    Object.keys(colors).forEach((colorName) => {
      const colorVar = getColorVar(colorName);
      if (colorVar) style.setProperty(colorVar, colors[colorName]);
    });
  }
});

// get accountData
if (
  state.account.hasOwnProperty("accountData") &&
  !_.isEmpty(state.account.accountData) &&
  !state.account.changedEmail &&
  !state.account.guestUser
) {
  const { internationalPrefix, phone } = state.account.accountData;
  store.dispatch(fetchUser(internationalPrefix, phone));
}

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCYC3AL_x62_uyMQLDe1hD-6aDMX6Sk9HQ",
  authDomain: "weclient-evio.firebaseapp.com",
  projectId: "weclient-evio",
  storageBucket: "weclient-evio.appspot.com",
  messagingSenderId: "1001671235676",
  appId: "1:1001671235676:web:0c9125f24cda67768fee99",
  measurementId: "G-56CF89NYVR",
};

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// const perf = getPerformance(app);

// logEvent(analytics, "notification_received");

// const t = trace(perf, "Tempo de Carregamento");
// t.start();

// setTimeout(() => {
//   t.stop();

//   t.putMetric("Tempo de Renderização", 1500); // Em milissegundos
// }, 2000);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
